import { __assign, __awaiter, __generator } from "tslib";
// @ts-ignore
import { AuthTypeEnum, DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
/**
  * @export
  * @enum {string}
  */
export var GetPrincipalAccessOrderByEnum = {
    Application: 'application',
    ResourceType: 'resource_type',
    Verb: 'verb'
};
/**
  * @export
  * @enum {string}
  */
export var GetPrincipalAccessStatusEnum = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    All: 'all'
};
var isGetPrincipalAccessObjectParams = function (params) {
    var l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true && Object.prototype.hasOwnProperty.call(params[0], 'application');
    }
    return false;
};
/**
* Access responses are sorted in ascending order by an ID internal to the database
* @summary Get the permitted access for a principal in the tenant (defaults to principal from the identity header)
* @param {GetPrincipalAccessParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export var getPrincipalAccessParamCreator = function (sendRequest) {
    var config = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        config[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, application, username, orderBy, status, limit, offset, _a, options, localVarPath, localVarUrlObj, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, args;
        return __generator(this, function (_b) {
            params = isGetPrincipalAccessObjectParams(config) ? config[0] : ['application', 'username', 'orderBy', 'status', 'limit', 'offset', 'options'].reduce(function (acc, curr, index) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[curr] = config[index], _a)));
            }, {});
            application = params.application, username = params.username, orderBy = params.orderBy, status = params.status, limit = params.limit, offset = params.offset, _a = params.options, options = _a === void 0 ? {} : _a;
            localVarPath = "/access/";
            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            localVarRequestOptions = __assign({ method: 'GET' }, options);
            localVarHeaderParameter = {};
            localVarQueryParameter = {};
            if (application !== undefined) {
                localVarQueryParameter['application'] = application;
            }
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            args = {
                urlObj: localVarUrlObj,
                options: localVarRequestOptions,
                auth: [
                    {
                        // authentication basic_auth required
                        // http basic authentication required
                        authType: AuthTypeEnum.Basic,
                    }
                ]
            };
            return [2 /*return*/, sendRequest(Promise.resolve(args))];
        });
    });
};
export default getPrincipalAccessParamCreator;
//# sourceMappingURL=index.js.map